import { useQuery } from '@tanstack/react-query'

import axios from 'axios'

const fetchUser = async () => {
  const { data } = await axios.get('/user', { withCredentials: true })
  return data
}

export const useAuth = ({ enabled = true }) => {
  return useQuery({
    queryKey: ['user-auth'],
    queryFn: fetchUser,
    enabled: enabled,
    retry: false,
    staleTime: 1000 * 60 * 5,
  })
}
